import styles from "./Modals.module.scss";
import React, { useRef } from "react";
import type { Destination } from "@whatslly/types/messages-server/destinations";
import { DESTINATION_INTEGRATION_TYPES } from "@whatslly/types/messages-server/destinations";
import { FormElement } from "@whatslly/ui-components/v2/FormElements/Form";
import { FormikErrors, FormikProps } from "formik";
import type { PartialRecord } from "@whatslly/commons/typescriptUtils";
import { Label } from "@whatslly/ui-components/v2/BaseElements/Label";
import { useTranslation } from "react-i18next";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { FormPasswordTextInput } from "@whatslly/ui-components/v2/FormElements/FormTextInput/FormPasswordTextInput";
import type { DestinationFormProps, FormDestinationDataType } from "../utils/DestinationsListTypes";
const BASE_DATA: Destination = { type: "coralogix" as const, integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES, settings: { apiKey: "" } };
type FormDataType = FormDestinationDataType<"coralogix">;

export const CoralogixModalForm: React.FC<DestinationFormProps<"coralogix">> = ({ settings, onSubmitForm }) => {
  const { t } = useTranslation();
  const formikContext = useRef<FormikProps<FormDataType>>(null);
  const validate = async (values: FormDataType) => {
    const errors: FormikErrors<PartialRecord<keyof FormDataType, string>> = {};
    if (!values.apiKey) {
      errors.apiKey = t("field_is_required");
    }
    return errors;
  };

  return (
    <FormElement
      initialValues={settings || BASE_DATA.settings}
      validate={validate}
      onSubmit={(data) => onSubmitForm({ ...BASE_DATA, settings: data })}
      formikRef={formikContext}
    >
      <div className={styles.field}>
        <Label className={styles.filedLabel} text={t("destinations_page.api_key")} />
        <FormPasswordTextInput name={"apiKey"} paddingInline="none" />
      </div>
      <ModalButtons
        submitText={t("destinations_page.save")}
        testId={"destination-ok-button"}
        onSubmit={() => formikContext.current?.submitForm()}
        hideCancel={true}
      />
    </FormElement>
  );
};
